import { getCookies, setCookie } from 'cookies-next';
import type { AppContext } from 'next/app';
import { v4 as uuidv4 } from 'uuid';

export const SESSION_ID_COOKIE_NAME = 'ennismore-sid';

export function getSessionIdFromContext(context: AppContext['ctx']): string {
  const cookies = getCookies(context);
  const existingSessionId = cookies[SESSION_ID_COOKIE_NAME];

  if (existingSessionId) {
    return existingSessionId;
  }

  const newSessionId = uuidv4();

  setCookie(SESSION_ID_COOKIE_NAME, newSessionId, {
    req: context.req,
    res: context.res,
    sameSite: 'strict',
    secure: process.env.NODE_ENV === 'production',
    httpOnly: true,
    path: '/',
    // No maxAge or expires = session cookie (deleted when browser closes)
  });

  return newSessionId;
}
